import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthService);

  username!: string;
  password!: string;
  haserror!: boolean;
  msg = "";
  loggingIn = false;
  skinPath =  environment.assets
  logoPath = "/assets/images/all_logos/" + environment.logoFile;




  ngOnInit(): void {
    const body = document.getElementsByTagName('body')[0];
    body.className = "";
    body.classList.add('login');
  }


  loginUser(): void {
    if (!this.username || !this.password || this.loggingIn) {
      return;
    }

    this.loggingIn = true;
    this.authService.loginUser(this.username, this.password).subscribe({
      next: (result) => {
        this.authService.startLocalSession(result.token);
        void this.authService.initializeLocalSession().then((authenticated) => {
          this.loggingIn = false;
          if (authenticated) {
            void this.router.navigate(['/']);
          } else {
            this.showInvalidCredentials();
          }
        });
      },
      error: () => {
        this.loggingIn = false;
        this.showInvalidCredentials();
      }
    });
  }

  private showInvalidCredentials(): void {
    this.haserror = true;
    this.msg = "Invalid Credentials";
  }

  getLogo(){
    if (environment.logoFile){
      return "assets/images/all_logos" + environment.logoFile
    }
    else{
      return "assets/images/all_logos/logo_MAAP-Logon.png"
    }
    
  }
}
